jQuery(function () {
  window.Sparkle.reloadMessageInbox = function (patientId, threadType, threadId) {
    const $container = jQuery("#messages-inbox-container");
    $container.html(Sparkle.spinner);

    const url = `/admin/patients/${patientId}/messages_inbox`;
    const params = {
      messages_tab: `tab_${threadType}`,
    };

    jQuery.get(url, params, function (data) {
      $container.html(data);
      Form.decorate();

      if (threadType && threadId) {
        jQuery(`.messages-inbox-thread[data-thread-type="${threadType}"][data-thread-id="${threadId}"]`).trigger(
          "click",
        );
      } else if (threadType === "text" && !threadId) {
        jQuery(".messages-inbox-thread:first-child").trigger("click");
      }
    });
  };

  jQuery(document).on("click", 'label[for~="tab_messages"]', function () {
    const patientId = jQuery("#messages-inbox-container").data("patient-id");
    Sparkle.reloadMessageInbox(patientId, "text");
  });

  if (jQuery("#messages-inbox-container").is(":visible")) {
    const $container = jQuery("#messages-inbox-container");
    const patientId = $container.data("patient-id");
    const threadId = $container.data("default-email-thread-id");
    const threadType = $container.data("thread-type") || "text";
    Sparkle.reloadMessageInbox(patientId, threadType, threadId);
  }

  function selectThread(threadType, threadId) {
    const $inbox = jQuery(`#${threadType}-messages-inbox`);
    $inbox.find(".messages-inbox-thread").removeClass("--selected");
    $inbox.find(`.messages-inbox-thread[data-thread-id=${threadId}]`).addClass("--selected");
  }

  function bindThreadSelection() {
    const $container = jQuery("#messages-inbox-container");

    $container.on("click", '[data-behaviour~="open-messages-thread"]', function (e) {
      const threadId = jQuery(this).data("thread-id");
      const patientId = jQuery(this).data("patient-id");
      selectThread("email", threadId);
      jQuery("#email-messages-inbox #email-messages-inbox-main").html(Sparkle.spinner);
      fetchMessages(patientId, threadId);
    });

    $container.on("click", '[data-behaviour~="open-text-messages-thread"]', function (e) {
      if (jQuery(e.target).parents(".dropdown").length === 0) {
        const threadId = jQuery(this).data("thread-id");
        const patientId = jQuery(this).data("patient-id");

        selectThread("text", threadId);
        fetchTextMessages(patientId, threadId);
      }
    });
  }

  function fetchMessages(patientId, threadId) {
    const url = `/admin/patients/${patientId}/messages_inbox/email_messages`;

    var params = {
      email_thread_id: threadId,
    };

    jQuery.get(url, params, (response) => {
      jQuery("#email-messages-inbox #email-messages-inbox-main").html(response);
    });
  }

  function fetchTextMessages(patientId, threadId) {
    const url = `/admin/patients/${patientId}/messages_inbox/text_messages`;

    var params = {
      text_thread_id: threadId,
    };

    jQuery.get(url, params, (response) => {
      jQuery("#text-messages-inbox #text-messages-inbox-main").html(response);
      Sparkle.prepareSendTextForm(document.querySelector("form.--patient-text-message-message_center"));
    });
  }

  window.Sparkle.messageHelpers = {};
  window.Sparkle.messageHelpers.togglePHIWarning = function (protectedMessageSelector) {
    let form = protectedMessageSelector.closest("form");
    form
      .querySelector("[ref=protected-message-hint]")
      .classList.toggle("--hidden", protectedMessageSelector.value == "0");
    if (form.querySelector("[ref=protected-message-errors]")) {
      form
        .querySelector("[ref=protected-message-errors]")
        .classList.toggle("--hidden", protectedMessageSelector.value != "0");
    }
  };

  window.Sparkle.messageHelpers.sendAsProtectedMessage = function (element) {
    let form = element.closest("form");
    form.querySelector("[ref=protected-message-selector]").value = 1;
    jQuery(form).trigger("submit.rails");
    return false;
  };

  bindThreadSelection();
});
